module.exports = __webpack_public_path__ + "static/media/footer-socialmedia-facebook.e72d4559.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/pullman/home/footer-socialmedia-facebook.svg
// module id = 1246
// module chunks = 0